<template>
    <div class="mtab" :class="[root.device=='phone'&&'notransform']">
        <van-row type="flex" class="mrow" >
           <van-col>
               <div @click="change(0)" class="mbtn" :class="{'active':cindex==0}">今日</div>
           </van-col>
           <van-col>
               <div @click="change(1)" class="mbtn" :class="{'active':cindex==1}">本周</div>
           </van-col>
           <van-col>
               <div @click="change(2)" class="mbtn" :class="{'active':cindex==2}">本月</div>
           </van-col>
        </van-row>

        <van-row class="mrow2" type="flex" justify="space-around" >
            <div class="item">
                <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i1.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                今日销售额                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data1.value1||0}}                                        
                        </div>
                    </div>
                </van-row>
            </div>
           <van-col class="item">
               <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i2.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                今日客单价                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data2.value1}}                                             
                        </div>
                    </div>
                </van-row>
              
           </van-col>
        </van-row>

        <van-row class="mrow2" type="flex" justify="space-around">
            <div class="item">
                <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i3.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                今日销售件数                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data3.value1}}                                       
                        </div>
                    </div>
                </van-row>
            </div>
           <van-col class="item">
               <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i4.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                在途商品总数                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data4.value1}}                                             
                        </div>
                    </div>
                </van-row>
              
           </van-col>
        </van-row>

        <van-row class="mrow2" type="flex" justify="space-around">
            <div class="item">
                <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i5.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                销售正价货品件数                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data5.value1}}                                           
                        </div>
                    </div>
                </van-row>
            </div>
           <van-col class="item">
               <van-row type="flex">                  
                    <img class="micon"  src="@/assets/i6.png"/>     
                    <div class="right">
                        <div class="txt1">                           
                                销售赠品件数                                           
                        </div>
                        <div class="txt2">                          
                                {{data.data6.value1}}                                             
                        </div>
                    </div>
                </van-row>
              
           </van-col>
        </van-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            cindex:this.index            
        }
    },
    inject:['root'],
    props:{
        index:{
            type:Number,
            default:0
        },
        data:{
            type:Object,
            default:{
                data1:{value1:'0',value2:'0'},
                 data2:{value1:'0',value2:'0'},
                 data3:{value1:'0',value2:'0'},
                 data4:{value1:'0',value2:'0'},
                 data5:{value1:'0',value2:'0'},
                 data6:{value1:'0',value2:'0'}
            }
        }
    },
    methods:{
        change(index){
            this.cindex=index
            this.$emit('change',this.cindex)
        }
    }
}
</script>
<style lang="scss" scoped>
 .device_pc{
.mtab{
   height:100%;
   display: flex;
   flex-direction: column;
 
}
.item{
    width:220px;
    .right{
          flex:1px;
          overflow: hidden;
    }
}
.mrow2{
 flex: 1;
   align-items: center;
}
.txt1{
  color: #b0b9ef;
  margin-bottom: 5px;
  font-size: 14px;
}
.txt2{
    color: #fff;
    font-size:32px;
     white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
 .micon{
     width:50px;
     height: 50px;
     margin-right: 15px;
 }



 .mrow{
    justify-content: space-around;
    width: 65%;
    margin: auto;
  
        flex:1;
    align-items: center;
 }
 .mbtn{
     
     cursor: pointer;
     width:120px;
     height: 36px;
     font-size:14px;
     color:#8789ff;
     border: 1px solid #8789ff;
     border-radius:5px ;
     text-align: center;
     line-height: 36px;
     background-color:#070918;
     &.active{
         color:#fff;
         background-color: #4346d3;
         border: 1px solid #4346d3;
     }
 }
  }








.device_phone{
.mtab{
   height:100%;
   display: flex;
   flex-direction: column;
     &.notransform{
        .mbtn{
        font-size:13px !important;
        }
     }
}
.item{
    width:700px;
    .right{
          flex:1px;
          overflow: hidden;
    }
}
.mrow2{
 flex: 1;
   align-items: center;
}
.txt1{
  color: #b0b9ef;
  margin-bottom: 5px;
  font-size: 14px;
}
.txt2{
    color: #fff;
    font-size:32px;
     white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
 .micon{
     width:150px;
     height: 150px;
     margin-right: 25px;
 }



 .mrow{
    justify-content: space-around;
    width: 85%;
    margin: auto;
  
        flex:1;
    align-items: center;
 }
 .mbtn{
     
     cursor: pointer;
     width:360px;
     height: 108px;
     font-size:14px;
     color:#8789ff;
     border: 1px solid #8789ff;
     border-radius:5px ;
     text-align: center;
     line-height: 108px;
     background-color:#070918;
     &.active{
         color:#fff;
         background-color: #4346d3;
         border: 1px solid #4346d3;
     }
 }
}
</style>